const e = {
  name: "SolutionData",
  dimensions: { width: 24, height: 24 },
  content: `
    <svg fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M21 22C21.5523 22 22 21.5523 22 21V3C22 2.44772 21.5523 2 21 2H9C8.44771 2 8 2.44772 8 3V8H3C2.44771 8 2 8.44771 2 9V21C2 21.5523 2.44771 22 3 22H21ZM16 20H20V4H10V8H15C15.5523 8 16 8.44771 16 9V20ZM8 10H4V20H8V10ZM10 20V10H14V20H10Z"/>
    </svg>    
  `
};
export {
  e as SolutionData
};
